import { useSelector } from 'react-redux'
import { levelsScoresColorData } from '../../../../../../models/heatMapData'
import classes from "./DistributionGraph.module.css"
import DonutChart from '../../../../../lms-shared/UI/Charts/DonutChart'
const DistributionGraph = ({ studentsSubmmissionList }) => {
    const texts = useSelector(state => state.translate.texts);
    const labeles = []
    const data = []
    const colors = []
    levelsScoresColorData.filter(l => l.maxScore).forEach((s, index) => {
        if (s.minScore || s.maxScore) {
            labeles[index] = s.ScoreThreshold;
            data[index] = studentsSubmmissionList.students.filter(student => student.studentScoreAverage * 100 > s.minScore && student.studentScoreAverage * 100 <= s.maxScore).length
            colors[index] = s.color
        }
    })

    return (

        <div className={classes.ChartSize}>
            <div className={classes.DonutChartChart}>
                <div className={classes.DonutChartTitle}>
                    <div className={classes.distributionIcon}></div>
                    <div >{texts.distribution}</div>
                </div>
                <div className={classes.ChartWarrper}>
                    <DonutChart dataChart={data} labelsChart={labeles} colors={colors}></DonutChart>
                </div>
            </div >
        </div>
    )
}
export default DistributionGraph